import {useCallback} from 'react';

import EppoFlags from '@/EppoFlags';
import {useStringAssignmentExperimentDetails} from '@/eppoHooks';
import useIdentity from '@/hooks/useIdentity';

/**
 * FixOurFoundationsNavbarPhase2a — arm gate plus a caller-driven exposure.
 */
const useFofNavbarPhase2a = () => {
  const {isLoggedIn, isMasquerading} = useIdentity();
  const {variation, trackExperimentExposed} = useStringAssignmentExperimentDetails(
    EppoFlags.FixOurFoundationsNavbarPhase2a,
  );

  const isEligible = isLoggedIn && !isMasquerading;

  const trackExposure = useCallback(() => {
    if (!isEligible || variation === 'fallback') return;

    trackExperimentExposed();
  }, [isEligible, variation, trackExperimentExposed]);

  const isFofNavbarPhase2aTreatment = isEligible && variation === 'treatment';

  return {isFofNavbarPhase2aTreatment, isEligible, variation, trackExposure};
};

export default useFofNavbarPhase2a;
